<div class="header-left">
  <ng-content select="header-left" />
</div>
<div class="header-right">
  <ng-content select="header-right" />
</div>
